import { api } from 'app/config/apiConfig';
import { CreateWaitingListEntryData, WaitingListEntry } from '../model/types';

export const createWaitingListEntryApi = api.injectEndpoints({
  endpoints: (builder) => ({
    createWaitingListEntry: builder.mutation<WaitingListEntry, CreateWaitingListEntryData>({
      query: (data) => ({
        url: '/waiting-list-entry',
        method: 'POST',
        body: data,
      }),
      invalidatesTags: ['Waiting list', 'Leads'],
    }),
  }),
});

export const { useCreateWaitingListEntryMutation } = createWaitingListEntryApi;
